export default "__VITE_ASSET__7hn8owk8__"